import { render, staticRenderFns } from "./StudentHome.vue?vue&type=template&id=60faaf9e&scoped=true&"
import script from "./StudentHome.vue?vue&type=script&scoped=true&lang=js&"
export * from "./StudentHome.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./StudentHome.vue?vue&type=style&index=0&id=60faaf9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60faaf9e",
  null
  
)

export default component.exports